import { render, staticRenderFns } from "./CommonDialogue.vue?vue&type=template&id=2a21cab3&scoped=true&"
import script from "./CommonDialogue.vue?vue&type=script&lang=ts&"
export * from "./CommonDialogue.vue?vue&type=script&lang=ts&"
import style0 from "./CommonDialogue.vue?vue&type=style&index=0&id=2a21cab3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a21cab3",
  null
  
)

export default component.exports